import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import DOMPurify from "dompurify";

const FaqHome = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [faqs, setFaqs] = useState([]);

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_FAQ_HOME;

        const cacheKey = "faqHomeData";
        const cacheTimeKey = "faqHomeDataTimestamp";
        const cacheExpiry = 30 * 60 * 1000; // 30 minutes

        const cachedFaqs = localStorage.getItem(cacheKey);
        const cacheTimestamp = localStorage.getItem(cacheTimeKey);

        if (cachedFaqs && cacheTimestamp && (Date.now() - parseInt(cacheTimestamp, 10)) < cacheExpiry) {
            setFaqs(JSON.parse(cachedFaqs));
        } else {
            axios.get(`${apiBaseUrl}${Url}`)
                .then(response => {
                    setFaqs(response.data);
                    localStorage.setItem(cacheKey, JSON.stringify(response.data));
                    localStorage.setItem(cacheTimeKey, Date.now().toString());
                })
                .catch(error => console.error('Failed to fetch Faqs:', error));
        }
    }, []);

    return (
        <div className="faq-area pt-100 pb-80">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="faq-content wow fadeInUp" data-wow-delay=".25s">
                            <div className="site-heading mb-3">
                                <span className="site-title-tagline"><i className="far fa-passport"></i> Faq's</span>
                                <h2 className="site-title my-3">আপনাদের জিজ্ঞাসিত প্রশ্নাবলী</h2>
                            </div>
                            <p className="mb-3"><img src="/assets/img/faq.webp" alt="FAQ" /></p>
                            <Link className="theme-btn mt-2 text-decoration-none" to={'/contact-us'}>
                                Have Any Question ?
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="accordion wow fadeInRight" data-wow-delay=".25s" id="accordionExample">
                            {faqs?.map((faq, index) => (
                                <div className="accordion-item" key={index}>
                                    <h2 className="accordion-header" id={`heading${index}`}>
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target={`#collapse${index}`} aria-expanded={index === 0}
                                                aria-controls={`collapse${index}`}>
                                            <span><i className="far fa-question"></i></span> {faq?.question}
                                        </button>
                                    </h2>
                                    <div id={`collapse${index}`} className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                                         aria-labelledby={`heading${index}`} data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            <div className="site-heading mb-3"
                                                 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(faq?.answer) }}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="country-wrap">
                            <div className="text-center my-2">
                                <Link className={'btn btn-success my-2'} to={'/faqs'}>
                                    আরো জানতে ক্লিক করুন <i className={'fa fa-plus'}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FaqHome;
